export const useDisplayNextMonthCalendar =
  ({ currentDateUTC, monthStateHandler, yearStateHandler }) =>
  ({ calendarCurrentMonth, calendarCurrentYear }) => {
    let nextMonth = calendarCurrentMonth + 1;
    if (
      nextMonth > currentDateUTC.getMonth() &&
      currentDateUTC.getFullYear() === calendarCurrentYear
    ) {
      // eslint-disable-next-line no-alert
      alert("Report is yet to be prepared");
      return;
    }
    if (nextMonth === 12) {
      nextMonth = 0;
      yearStateHandler(calendarCurrentYear + 1);
    }
    monthStateHandler(nextMonth);
  };
